module.exports = __webpack_public_path__ + "img/sc5_001.cb5214fd.png";